// people-bios.js

var $ = require('jquery');
var remodal = require('remodal');
var slick = require('slick-carousel');
var Rellax = require('rellax');
var peopleSlick = null;

$(document).ready(function() {
	//parallaxSpotlight();
	
	if ($(".editor-styles-wrapper").length > 1) {
		return;
	}

	var options = {};	

	$(".people-bios").on("click", ".people-bio__link", function (e) {

		var action = $(this).parents(".people-bios").hasClass("people-bios--spotlight") ? "quote" : "view";
		var id = $(this).parent().data("post-id");
		var modal = $('[data-remodal-id='+action+'--'+id+']').remodal(options);
		modal.open();
		
		return false;
	});

	// peopleSlick = $(".people-bios--spotlight .container").slick({
	//   dots: false,
	//   arrows: true,
	//   infinite: false,
	//   autoplay: false,
	//   speed: 300,
	//   slidesToShow: 1,
	//   mobileFirst: true,
	//   slidesToScroll: 3,
	//   responsive: [
	// 	{
	// 		breakpoint: 1100,
	// 		settings: 'unslick'
	// 	},
	//     {
	//       breakpoint: 991,
	//       settings: {
	//         slidesToShow: 2,
	//         slidesToScroll: 2
	//       }
	//     },
	//   ]
	// });
})


$(window).on('resize', function(){
	if ( peopleSlick == null && $(window).width() <= 1099 )  {
		peopleSlick = $(".people-bios--spotlight .container").slick({
			dots: false,
			arrows: true,
			infinite: false,
			autoplay: false,
			speed: 300,
			slidesToShow: 1,
			mobileFirst: true,
			slidesToScroll: 1,
			responsive: [
			  {
				  breakpoint: 1100,
				  settings: 'unslick'
			  },
			  {
				breakpoint: 768,
				settings: {
				  slidesToShow: 2,
				  slidesToScroll: 2
				}
			  },
			]
		});
	} else if ( $(window).width() > 1099 ) {
		peopleSlick = null;
	}
}).trigger('resize');


function parallaxSpotlight() {
	$('.people-bios--spotlight').each(function() {
		// let people = $(this).find('.people-bio__post');
		// people.each(function(index, el) {
		// 	$(this).attr('data-rellax-speed', index+1);
		// })

		var rellax = null;
		$(window).on('resize', function() {
			if ( $(window).width() > 991 && rellax == null ) {
				rellax = new Rellax('.people-bio__post', {
					breakpoint:[ 768, 991, 1099 ],
					center: true,
				});
			} else if (rellax !== null && $(window).width() <= 991 ) {
				rellax.destroy();
				rellax = null;
			}
		}).trigger('resize');
	})
}